import React from 'react';
import PropTypes from 'prop-types';
import {
  ContentInfo,
  ContentNumber,
  ContentText,
  ContentAmount,
} from './styles/ItemContentStyled';
import { Numbers } from '../../../../helpers';

const ItemContent = ({ data }) => {
  const info = data.map((item, i) => {
    const amount = Numbers.addThousandSeparators(item.amount).replace(
      /^(-)?/,
      '$1$'
    );
    const key = i;

    return (
      <ContentInfo key={key}>
        <div>
          <ContentNumber>{`+${item.line}`}</ContentNumber>
          <ContentText>{item.name}</ContentText>
        </div>

        <ContentAmount>{amount}</ContentAmount>
      </ContentInfo>
    );
  });

  return <>{info}</>;
};

ItemContent.propTypes = {
  data: PropTypes.arrayOf(Object).isRequired,
};

export default ItemContent;
